import React, {useEffect, useState } from "react";
import "./AboutPage.css";
import Navbar from "./Navbar";
import BreadCrumb from "./BreadCrumb";
import Footer from "./Footer";
import { FaBolt, FaShieldAlt, FaDollarSign, FaSyncAlt, FaGlobe, FaChartLine, FaArrowRight } from "react-icons/fa";
import Download from "./Download";
import MediaCenter from "./MediaCenter";
import Newsletter from "./Newsletter";


const AboutPage = () => {
  const [activeSection, setActiveSection] = useState("about");
  useEffect(() => {
    const storedSection = sessionStorage.getItem("activeSection");
    if (storedSection) {
      setActiveSection(storedSection);
      sessionStorage.removeItem("activeSection"); // Clear after applying
    }
  }, []);

  return (
    <>
      <Navbar />
      <BreadCrumb />
      <div className="about-container">
        {/* Navigation Buttons */}
        <div className="about-nav">
        <button
          className={activeSection === "about" ? "active" : ""}
          onClick={() => setActiveSection("about")}
        >
          About RiseFX
        </button>
        <button
          className={activeSection === "mission" ? "active" : ""}
          onClick={() => setActiveSection("mission")}
        >
          Our Mission & Vision
        </button>
        <button
          className={activeSection === "services" ? "active" : ""}
          onClick={() => setActiveSection("services")}
        >
          Our Service
        </button>
        <button
          className={activeSection === "why" ? "active" : ""}
          onClick={() => setActiveSection("why")}
        >
          Why Rise Fx
        </button>
      </div>


        {/* Section Content */}
        <div className="about-content">
          {activeSection === "about" && (
            <section className="about-section mission">
              <h1>About RiseFX</h1>
              <h2> Welcome to RiseFX – Your Trusted Forex Trading Partner </h2>
              <p className="risefx-description">
                At RiseFX, we believe in revolutionizing the way traders engage with the financial markets. Our mission is to provide a transparent, secure, and technologically advanced trading environment where traders of all levels can thrive. With a strong foundation built on integrity and innovation, we stand apart as a forex broker that prioritizes client success and market excellence.
              </p>
              <h2>What Sets RiseFX Apart?</h2>
              <h3>1. Lightning-Fast Execution</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                Speed matters in trading. With ultra-low latency execution and advanced trading infrastructure, we ensure that your trades are executed in milliseconds, reducing slippage and maximizing profitability.
              </p>
              <h3>2. Tight Spreads & Low Commissions</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                Enjoy some of the tightest spreads in the industry, starting from 0.0 pips. Our transparent pricing model ensures that you trade with minimal costs and no hidden charges.
              </p>
              <h3>3. Regulated & Secure</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                We adhere to the highest financial regulatory standards, ensuring fund security, data protection, and operational transparency. Your trust is our top priority.
              </p>
              <h3>4. Cutting-Edge Technology</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                We empower traders with state-of-the-art trading platforms, AI-powered market analytics, and automated trading solutions to stay ahead in the dynamic forex market.
              </p>
              <h3>5. Diverse Trading Instruments</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                Trade beyond forex! With indices, commodities, cryptocurrencies, you can diversify your portfolio and explore new opportunities—all on one platform.
              </p>
              <h3>6. Flexible Account Types</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                Whether you're a beginner, a professional, or an institutional trader, we offer tailored account options to suit your specific trading needs.
              </p>
              <h3>7. Seamless Deposits & Withdrawals</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                We provide secure and instant payment options, including bank transfers, credit cards, e-wallets, and cryptocurrency, ensuring fast and hassle-free transactions.
              </p>
              <h3>8. Dedicated Customer Support</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                Our 24/5 multilingual support team is available via live chat, email, and phone to assist you with any queries, ensuring you receive the support you need, whenever you need it.
              </p>
              <h3>9. Innovative Trading Tools</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                With copy trading, advanced risk management features, and AI-driven market insights, we equip traders with the tools they need to succeed.
              </p>
              <h3>10. Educational Support & Market Insights</h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                We believe in empowering traders with knowledge. Our free webinars, expert market analysis, and in-depth trading courses help traders sharpen their skills and stay ahead of the curve.
              </p>

            </section>
          )}



          {activeSection === "mission" && (
            <section className="about-section mission">
              <h1>Our Mission & Vision</h1>
              <h2> Let's start trading with confidence because your victory is our priority! </h2>
              <h3>Our Mission: </h3>
              <p className="risefx-description">
                To provide a best-in-class trading experience driven by innovation, transparency, and a client-first approach. We aim to bridge the gap between traders and the global financial markets with cutting-edge technology and top-tier liquidity.
              </p>
              <h3>Our Vision: </h3>
              <p className="risefx-description" style={{ marginLeft: '0' }}>
                To become the most trusted and customer-centric forex broker, setting new standards in reliability, transparency, and innovation across the industry.
              </p>

              <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', alignItems: 'center' }}>
                <FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                Direct Market Access with institutional-grade liquidity.
              </p>
              <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', alignItems: 'center' }}>
                <FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                No dealing desk execution ensures a conflict-free trading environment.
              </p>
              <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', alignItems: 'center' }}>
                <FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                Advanced Trading Tools, including AI-powered analysis and automated trading strategies.
              </p>
              <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', alignItems: 'center' }}>
                <FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                Strict regulatory compliance and fund security measures.
              </p>
              <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', alignItems: 'center' }}>
                <FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                Constant Innovation, adapting to market trends and trader needs.
              </p>
              <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', alignItems: 'center' }}>
                <FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                At RiseFX, we are more than just a broker—we are your partner in trading success. Join us today and experience the future of forex trading with a broker you can trust!
              </p>
              <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', alignItems: 'center' }}>
                <FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                Start Trading with RiseFX Today! 
              </p>
                <div className='navbar-child nav-btns'>
                  <a href='https://panel.therisefx.com/register'>
                    <button className='btn-open-account'>Open Account</button>
                  </a>
                  <a href='https://panel.therisefx.com/login'>
                    <button className='btn-login'>Login</button>
                  </a>
                </div>
            </section>
          )}




          {activeSection === "services" && (
            <section className="about-section services">
              <div className="container">
                <h1 className="section-title">Our Services</h1>
                <h2 className="section-subtitle">
                Choose the Best Stock Broker Online
                </h2>
                <p className="section-description">
                Whether you're a beginner or an expert in <strong>Forex Trading, Indices Trading, Commodities Trading, or Metal Trading</strong>, RiseFX is your trusted platform for maximizing returns.
                </p>
                <p className="section-description">
                Our platform offers real-time forex currency trading news, ensuring informed decision-making at every step. With competitive pricing, expert support, and global market access, RiseFX stands out as the best online stock broker.
                </p>
                <p className="section-description">
                At RiseFX, we provide a world-class online trading platform with 24/5 support, ultra-tight spreads, and zero deposit fees. Whether you’re a beginner or an expert, our fast, secure, and reliable trading environment ensures the best experience for you.
                </p>

                <div className="services-grid">
                  <div className="service-card">
                    <h3>Forex Trading</h3>
                    <p>
                      Buy and sell major and minor currency pairs with <span>fast execution</span> and <span>low spreads</span>.
                      Enjoy real-time market analysis and professional tools designed for all experience levels.
                    </p>
                  </div>
                  <div className="service-card">
                    <h3>CFD Trading</h3>
                    <p>
                      Trade stocks, commodities, indices, and crypto without purchasing the assets.
                      Benefit from flexible leverage, low fees, and expert insights.
                    </p>
                  </div>
                  <div className="service-card">
                    <h3>Commodities Trading</h3>
                    <p>
                      Invest in gold, silver, oil, and more with real-time price updates and expert analysis.
                      Our platform provides secure and seamless access to global commodity markets.
                    </p>
                  </div>
                  <div className="service-card">
                    <h3>Indices Trading</h3>
                    <p>
                      Trade major global indices such as <span>S&P 500, NASDAQ, and FTSE 100</span> with low spreads,
                      high liquidity, and real-time performance tracking.
                    </p>
                  </div>
                  <div className="service-card">
                    <h3>Educational Resources</h3>
                    <p>
                      Learn with expert webinars, real-time market insights, and interactive tutorials.
                      Use a demo account to practice risk-free before trading live.
                    </p>
                  </div>
                  <div className="service-card">
                    <h3>24/5 Personalized Support</h3>
                    <p>
                      Get dedicated assistance from professional traders. Benefit from private guidance sessions,
                      expert market insights, and multilingual support.
                    </p>
                  </div>
                </div>
                <a href='https://panel.therisefx.com/register'>
                <button className="cta-button">Start Trading Now</button>
                </a>
              </div>
            </section>
          )}
          {activeSection === "why" && (
            <section className="about-section risefx-benefits-section">
              <div className="risefx-container">
                <h1 className="risefx-title">Why Choose RiseFX?</h1>
                <h2 className="risefx-subtitle">
                  Trade with confidence because your success is our priority!
                </h2>
                <p className="risefx-description">
                  At RiseFX, we provide a world-class online trading platform with <span>24/5 support</span>,
                  <span>ultra-tight spreads</span>, and <span>zero deposit fees</span>. Whether you’re a beginner or
                  an expert, our <span>fast, secure, and reliable</span> trading environment ensures the best
                  experience for you.
                </p>

                {/* Features Grid */}
                <div className="risefx-features-grid">
                  <div className="risefx-feature-card">
                    <FaBolt className="risefx-icon" />
                    <h3>Ultra-tight Spreads</h3>
                    <p>Trade with the lowest price differences. Lower costs mean more profit.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaShieldAlt className="risefx-icon" />
                    <h3>Dedicated Customer Service</h3>
                    <p>24/5 expert support, private sessions, and multi-language assistance.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaChartLine className="risefx-icon" />
                    <h3>Fast & Stable Trading</h3>
                    <p>Experience smooth, delay-free trading on both desktop & mobile.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaSyncAlt className="risefx-icon" />
                    <h3>Hassle-free Transactions</h3>
                    <p>Quick, secure deposits & withdrawals with zero hidden fees.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaGlobe className="risefx-icon" />
                    <h3>Top Institutional Liquidity</h3>
                    <p>Access deep liquidity for the best market prices with fast execution.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaDollarSign className="risefx-icon" />
                    <h3>Trust & Transparency</h3>
                    <p>No hidden fees, full transparency, and secure fund management.</p>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
      <MediaCenter />
      <Download />
      <Newsletter />
      <Footer />
    </>
  );
};

export default AboutPage;
